import React from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentGeoentity, selectGeoentityRubricId } from '../../../store/geoentity/geoentity.selectors'
import { hasTouchSupport } from '../../Device'
import useErrorBoundaryCallback from '../../utils/useErrorBoundaryCallback'
import useEventCallback from '../../utils/useEventCallback'
import Marker from './Marker'

const PoiMarker = ({
  id,
  additionalInfo,
  isCurrent,
  shouldNavigateToPoiOnTap,
  navigateToPoi,
  focusPoi,
  unfocusPoi,
  vde,
  ...marker
}) => {
  const rubricId = selectGeoentityRubricId({}, { geoentity: marker })
  const currentGeoentity = useSelector(selectCurrentGeoentity)

  const onSelect = useErrorBoundaryCallback(() => {
    // on PE, on a POI page with pois around,
    // we want to go to a POI on first tap
    if (shouldNavigateToPoiOnTap && currentGeoentity) {
      navigateToPoi({ id, additionalInfo, rubricId, vde })
    } else {
      focusPoi(id)
    }
  }, [navigateToPoi, focusPoi, shouldNavigateToPoiOnTap, currentGeoentity])

  const onUnselect = useErrorBoundaryCallback(() => {
    unfocusPoi(id)
  }, [unfocusPoi])

  const onClick = useEventCallback(() => {
    // on PE, on a search page,
    // on 1st tap we want to focus (display the popin poi info)
    // on 2nd tap to navigate to Poi
    if (hasTouchSupport() && !isCurrent) {
      onSelect()
    } else {
      navigateToPoi({ id, additionalInfo, rubricId, vde })
    }
  }, [isCurrent, onSelect, navigateToPoi])

  return <Marker isCurrent={isCurrent} onSelect={onSelect} onUnselect={onUnselect} onClick={onClick} {...marker} />
}

export default React.memo(PoiMarker, (props, nextProps) => {
  return props.isCurrent === nextProps.isCurrent
})
